import React, { useState, useEffect } from 'react';
import './Header.css';
import logo from '../../img/logos2.png';

const Header = ({ onMenuToggle, onNavClick, isMenuOpen }) => {
  const [isHamActive, setIsHamActive] = useState(false);

  // Синхронизируем состояние бургера с состоянием меню
  useEffect(() => {
    setIsHamActive(isMenuOpen);
  }, [isMenuOpen]);

  const toggleMenu = () => {
    const newState = !isHamActive;
    setIsHamActive(newState);
    onMenuToggle(); // Просто вызываем без передачи состояния
  };

  return (
    <header className="header">
      <div className="header-container">
        <div className="menu-toggle" onClick={toggleMenu}>
          <svg className={`hamburger ${isHamActive ? 'active' : ''}`} viewBox="0 0 100 100" width="65">
            <path className="line top" d="m 30,33 h 40 c 3.722839,0 7.5,3.126468 7.5,8.578427 0,5.451959 -2.727029,8.421573 -7.5,8.421573 h -20" />
            <path className="line middle" d="m 30,50 h 40" />
            <path className="line bottom" d="m 70,67 h -40 c 0,0 -7.5,-0.802118 -7.5,-8.365747 0,-7.563629 7.5,-8.634253 7.5,-8.634253 h 20" />
          </svg>
        </div>
        
        <div className="header-phone" onClick={() => window.open('tel:+79871329881')}>
          <a href="tel:+79871329881">+7(987)13-29-881</a>
        </div>
        
        <div className="header-logo">
          <img src={logo} alt="Гостиница Белая" />
        </div>
        
        <div className="header-description">
          <span>Проживание и другие услуги для иностранных<br/>граждан в Уфе: регистрация, постановка на учет.</span>
        </div>
        
        <div className="header-telegram" onClick={() => window.location.href='https://t.me/+79871329881'}>
          <a href="https://t.me/+79871329881" target="_blank" rel="noopener noreferrer">Telegram</a>
        </div>
      </div>
    </header>
  );
};

export default Header;